var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMGenerico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-comunidad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.72,18.43l9,24.19L37.23,50.54,54.49,33.28a.4.4,0,0,0,0-.56L42.77,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,54.77,11.51,33.28a.4.4,0,0,1,0-.56L32.72,11.51a.4.4,0,0,1,.56,0l7.54,7.54L49,16,33.28.28a.4.4,0,0,0-.56,0L.28,32.72a.4.4,0,0,0,0,.56L32.72,65.72a.4.4,0,0,0,.56,0L50.81,48.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,53,20,60,39l5.72-5.72A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.83,15.36,49,16,53,20l-1.61-4.36A.4.4,0,0,0,50.83,15.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.67,42.62,55,44l-4.23,4.23,10.69-4a.39.39,0,0,0,.24-.51L60,39l-2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49,16l-8.2,3-7.54-7.54a.4.4,0,0,0-.56,0L11.51,32.72a.4.4,0,0,0,0,.56L33,54.77l17.81-6.58L55,44,37.23,50.54,54.49,33.28a.4.4,0,0,0,0-.56L42.77,21l6.95-2.57L58.05,41l2-2L53,20Zm2.22,17L33,51.24,14.76,33,33,14.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,14.76,14.76,33,33,51.24,51.24,33Zm8.1,19.49H34.25V41.1a.4.4,0,0,1-.4.4h-1.7a.4.4,0,0,1-.4-.4V34.25H24.9a.4.4,0,0,1-.4-.4v-1.7a.4.4,0,0,1,.4-.4h6.85V24.9a.4.4,0,0,1,.4-.4h1.7a.4.4,0,0,1,.4.4v6.85H41.1a.4.4,0,0,1,.4.4v1.7A.4.4,0,0,1,41.1,34.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.1,31.75H34.25V24.9a.4.4,0,0,0-.4-.4h-1.7a.4.4,0,0,0-.4.4v6.85H24.9a.4.4,0,0,0-.4.4v1.7a.4.4,0,0,0,.4.4h6.85V41.1a.4.4,0,0,0,.4.4h1.7a.4.4,0,0,0,.4-.4V34.25H41.1a.4.4,0,0,0,.4-.4v-1.7A.4.4,0,0,0,41.1,31.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMGenerico);
export default __webpack_public_path__ + "static/media/m_generico.e5a1bbdcfaddfeb2bc4a30048e9e1420.svg";
export { ForwardRef as ReactComponent };